<template>
  <v-container fluid>
    <v-layout row justify-end class="button-padding">
      <div>
        <v-btn
          color="primary"
          depressed
          large
          :disabled="!isInvoiceSelected()"
          :loading="loading"
          @click="bulkDownload()"
        >Herunterladen</v-btn>
      </div>
    </v-layout>
    <v-layout
      column
      fill-height
      id="allEmployeeInvoices"
      style="max-height: calc(100vh - 192px);"
      class="overflow-y-auto"
    >
      <v-flex
        v-scroll:#allEmployeeInvoices="onScroll"
        align="center"
        justify="center"
      >
        <v-list v-for="(monthGroup, index) in monthlyGroupInvoices" v-bind:key="monthGroup.month">
          <v-flex class="month-header">
            <v-checkbox color="primary"
              v-model="selectedMonths[index]"
              @change="monthSelectionChanged(monthGroup.month, $event)"
            >
              <template v-slot:label>
                <div><strong class="primary--text month-header-text">{{mapYearMonth(monthGroup.month)}}</strong></div>
              </template>
            </v-checkbox>
          </v-flex>
          <template v-for="(invoice, invoiceIndex) in monthGroup.invoices">
            <v-list-item v-if="invoiceIndex % 2 === 1"
              :key="invoice.id" style="background-color: #B3E5FC40">
              <v-checkbox
                color="black"
                v-model="selectedInvoices[invoice.id]"
                @change="invoiceSelectionChanged(invoice, index, $event)"
              ></v-checkbox>
              <v-list-item-content>
                <v-list-item-title>{{listItemLabel1(invoice)}}</v-list-item-title>
                <v-list-item-subtitle>{{listItemLabel2(invoice)}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                       @click="openEmployeeInvoice(invoice.id)">
                  <v-icon color="primary">receipt</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-else
              :key="invoice.id">
              <v-checkbox
                color="black"
                v-model="selectedInvoices[invoice.id]"
                @change="invoiceSelectionChanged(invoice, index, $event)"
              ></v-checkbox>
              <v-list-item-content>
                <v-list-item-title>{{listItemLabel1(invoice)}}</v-list-item-title>
                <v-list-item-subtitle>{{listItemLabel2(invoice)}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text icon :disabled="isRowDisabled(invoice.id)"
                @click="openEmployeeInvoice(invoice.id)">
                  <v-icon color="primary">receipt</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
            v-if="invoiceIndex + 1 < monthGroup.invoices.length"
            :key="monthGroup+'-divider-'+invoiceIndex"
            ></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'EmployeeInvoiceList',
    data () {
      return {
        page: 0,
        size: 50,
        bottom: false,
        disabledInvoice: 0,
        selectedMonth: '',
        selectedMonths: [],
        selectedInvoices: []
      }
    },
    computed: {
      monthlyGroupInvoices: function () {
        return this.$store.getters.employeeInvoices
      },
      disabled: function () {
        return this.$store.getters.startDataLoading
      },
      loading: function () {
        return this.$store.getters.loading
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom) {
          this.page++
          this.loadEmployeeInvoices()
        }
      },
      disabled (newValue, oldValue) {
        if (!newValue) {
          this.disabledInvoice = 0
        }
      },
      monthlyGroupInvoices: {
        deep: true,
        handler () {
          this.selectAllInvoicesOfSelectedMonth()
        }
      }
    },
    created () {
      this.$store.dispatch('resetEmployerInvoices')
      window.addEventListener('scroll', () => {
        this.bottom = this.onScroll()
      })
      this.loadEmployeeInvoices()
    },
    methods: {
      loadEmployeeInvoices: function (searchTerm) {
        this.$store.dispatch('loadEmployeeInvoices', {
          page: this.page,
          size: this.size
        })
      },
      monthSelectionChanged: function (month, event) {
        if (event) {
          this.selectedMonth = month
          this.selectAllInvoicesOfSelectedMonth()
        } else {
          this.deselectAllInvoicesOfSelectedMonth()
          this.selectedMonth = ''
        }
      },
      selectAllInvoicesOfSelectedMonth: function () {
        this.monthlyGroupInvoices.forEach(monthGroup => {
          monthGroup.invoices.forEach(invoice => {
            if (this.selectedMonth === monthGroup.month) {
              this.selectedInvoices[invoice.id] = true
            }
          })
        })
      },
      deselectAllInvoicesOfSelectedMonth: function () {
        this.monthlyGroupInvoices.forEach(monthGroup => {
          monthGroup.invoices.forEach(invoice => {
            if (this.selectedMonth === monthGroup.month) {
              this.selectedInvoices[invoice.id] = false
            }
          })
        })
      },
      invoiceSelectionChanged: function (invoice, monthIndex, event) {
        if (event) {
          console.log('')
        } else {
          this.selectedMonths[monthIndex] = event
          this.selectedMonth = ''
        }
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      isRowDisabled: function (invoiceId) {
        return this.disabledInvoice === invoiceId
      },
      openEmployeeInvoice: function (id) {
        this.$store.dispatch('openInvoice', id)
      },
      mapYearMonth: function (yearMonth) {
        const splitted = yearMonth.split('-')
        const date = new Date(splitted[0], splitted[1] - 1)
        return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0]
      },
      isInvoiceSelected: function () {
        return this.selectedInvoices.some((element) => element === true)
      },
      getSelectedInvoiceIds: function () {
        return this.selectedInvoices
          .map((value, index) => ({id: index, selected: value}))
          .filter((element) => element.selected === true)
          .map((element) => element.id)
      },
      bulkDownload: function () {
        if (this.selectedMonth) {
          this.$store.dispatch('bulkEmployeeInvoiceDownloadByMonth', this.selectedMonth)
        } else {
          const selectedInvoiceIds = this.getSelectedInvoiceIds()
          if (selectedInvoiceIds.length === 1) {
            this.openCustomerInvoice(selectedInvoiceIds[0])
          } else {
            this.$store.dispatch('bulkEmployeeInvoiceDownloadByInvoices', selectedInvoiceIds)
          }
        }
        this.selectedMonth = ''
        this.selectedMonths = []
        this.selectedInvoices = []
      },
      listItemLabel1: function (invoice) {
        if (invoice.type.toUpperCase() === 'EMPLOYEE_INVOICE') {
          return invoice.employee.firstName + ' ' + invoice.employee.lastName
        }
      },
      listItemLabel2: function (invoice) {
        if (invoice.type.toUpperCase() === 'EMPLOYEE_INVOICE') {
          return invoice.employee.zipCode + ' ' + invoice.employee.city
        }
      }
    }
  }
</script>

<style scoped>
  .v-list-item {
      max-height: 50px;
  }
  .button-padding {
    padding-right: 30px;
  }

  .month-header {
    max-height: 35px;
    margin-left: 16px;
    margin-bottom: 5px;
  }

  .month-header-text {
    font-size: x-large;
  }
</style>



// WEBPACK FOOTER //
// src/components/Invoices/EmployeeInvoiceList.vue